import { useRef } from 'react'

import { DeliveryList } from '@/compositions/delivery-list'
import { FormFilter } from '@/compositions/form-filters-delivery'
import { FormFilterRef } from '@/compositions/form-filters-delivery/ref'
import { useDeliveryContext } from '@/contexts/delivery.context'

const DeliveryView = () => {
  const filterFormRef = useRef<FormFilterRef>(null)

  const { setTableData, handleFilter, setPage, setResults, handleLimitChange, limit } = useDeliveryContext()

  const handleClearForm = () => {
    if (filterFormRef.current) {
      filterFormRef.current.clearForm()
      setTableData([])
      setResults(0)
      setPage(1)
      handleLimitChange(10)
    }
  }

  return (
    <>
      <FormFilter
        ref={filterFormRef}
        onFilters={handleFilter}
        onClear={handleClearForm}
        limit={limit}
        onLimitChange={handleLimitChange}
      />

      <DeliveryList />
    </>
  )
}

export default DeliveryView
